<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link :to="'/' + username + '/home'">
        <i class="nc-icon nc-globe-2"></i>
        <p>داشبورد</p>
      </sidebar-link>
      <sidebar-link :to="'/' + username + '/myexps'">
        <i class="nc-icon nc-badge"></i>
        <p style="direction: rtl;">Exp های من</p>
      </sidebar-link>
      <sidebar-link :to="'/' + username + '/myresponses'">
        <i class="nc-icon nc-chat-round"></i>
        <p>پاسخ های من</p>
      </sidebar-link>
      <sidebar-link :to="'/' + username + '/notifications'">
        <i class="nc-icon nc-bell-55"></i>
        <p>اعلان ها</p>
      </sidebar-link>
      <sidebar-link :to="'/' + username + '/profile'">
        <i class="nc-icon nc-circle-09"></i>
        <p>پروفایل</p>
      </sidebar-link>

      
      <template slot="bottom-links">
        <sidebar-link :to="'/' + username + '/newexp'" :attention="true">
          <i class="nc-icon nc-send"></i> 
          <p>جدید Exp</p>
        </sidebar-link>
        <sidebar-link class="active" :to="'/' + username + '/upgrade'">
          <i class="nc-icon nc-alien-33"></i>
          <p>ارتقاع</p>
        </sidebar-link>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="console.log('clicked')">
      </dashboard-content>

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from './TopNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import MobileMenu from './MobileMenu.vue';
export default {
  data() {
    return {
      username: "Admin",
    }
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  created() {
    this.username = localStorage.getItem('username');
  },
  methods: {
    toggleSidebar() {
      console.log("hehere .. ");
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}

</script>
